/*
 * Pipeline Theme — Custom JavaScript
 * Safe place for custom behavior so theme updates are easier.
 */

(function () {
  // Keep custom scripts inside this IIFE to avoid leaking globals.

  /* ============================================================
   * 0) Petticoat Lane predictive search result count
   *    Pipeline requests a small result set. Keep the theme code
   *    untouched and safely raise predictive results to 8 per type.
   * ============================================================ */
  if (!window.__plPredictiveFetchPatched && typeof window.fetch === 'function') {
    var plOriginalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        var rawUrl = typeof input === 'string' ? input : (input && input.url ? input.url : '');
        var isPredictiveSearch = rawUrl && (
          rawUrl.indexOf('/search/suggest') !== -1 ||
          rawUrl.indexOf('section_id=predictive-search') !== -1
        );

        if (isPredictiveSearch) {
          var parsedUrl = new URL(rawUrl, window.location.origin);
          parsedUrl.searchParams.set('resources[limit]', '8');
          parsedUrl.searchParams.set('resources[limit_scope]', 'each');
          var adjustedUrl = parsedUrl.toString();

          if (typeof input === 'string') {
            input = adjustedUrl;
          } else if (typeof Request !== 'undefined' && input instanceof Request) {
            input = new Request(adjustedUrl, input);
          }
        }
      } catch (error) {
        console.warn('Petticoat Lane predictive search adjustment skipped:', error);
      }

      return plOriginalFetch.call(this, input, init);
    };

    window.__plPredictiveFetchPatched = true;
  }

  /* ============================================================
   * 1) Collection Load More: fetch + append + auto-trigger
   *    Requires:
   *      - #pl-grid (product grid wrapper)
   *      - #pl-loadmore (wrapper) with data-next="next page url"
   * ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    if (true) return;
    var grid = document.querySelector('#pl-grid');
    var wrap = document.querySelector('#pl-loadmore');
    var button = wrap ? wrap.querySelector('button, a') : null;

    if (!grid || !wrap || !button) return;

    var loading = false;
    var io = null;

    async function loadNextPage() {
      if (loading) return;

      var nextUrl = wrap.getAttribute('data-next');
      if (!nextUrl) return;

      loading = true;
      if ('disabled' in button) button.disabled = true;
      wrap.classList.add('is-loading');

      try {
        var res = await fetch(nextUrl, { credentials: 'same-origin' });
        if (!res.ok) throw new Error('Network error ' + res.status);

        var html = await res.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var nextGrid = doc.querySelector('#pl-grid');
        var nextWrap = doc.querySelector('#pl-loadmore');

        if (nextGrid && nextGrid.innerHTML) {
          grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        }

        if (nextWrap && nextWrap.getAttribute('data-next')) {
          wrap.setAttribute('data-next', nextWrap.getAttribute('data-next'));
          if ('disabled' in button) button.disabled = false;
        } else {
          if (io) io.disconnect();
          wrap.remove();
        }
      } catch (e) {
        console.error(e);
        window.location.href = wrap.getAttribute('data-next') || window.location.href;
      } finally {
        loading = false;
        wrap.classList.remove('is-loading');
      }
    }

    button.addEventListener('click', function (e) {
      e.preventDefault();
      loadNextPage();
    });

    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (ent) {
            if (ent.isIntersecting && !loading && !(button && button.disabled)) {
              loadNextPage();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(wrap);
    }
  });

  /* ============================================================
   * 2) Brands A–Z Overlay
   * ============================================================ */
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.getElementById('BrandsOverlay');
    if (!overlay) return;

    var closeBtn = overlay.querySelector('[data-close]');
    var search = document.getElementById('BrandsSearch');

    var tabAll = document.getElementById('tabAll');
    var tabLing = document.getElementById('tabLing');
    var tabSwim = document.getElementById('tabSwim');
    var tabApp = document.getElementById('tabApp');
    var tabSleep = document.getElementById('tabSleep');

    var panelAll = document.getElementById('panelAll');
    var panelLing = document.getElementById('panelLing');
    var panelSwim = document.getElementById('panelSwim');
    var panelApp = document.getElementById('panelApp');
    var panelSleep = document.getElementById('panelSleep');

    function updateLetterJumps(which) {
      var prefixes = {
        all: 'brands-',
        lingerie: 'brands-ling-',
        swimwear: 'brands-swim-',
        apparel: 'brands-app-',
        sleepwear: 'brands-sleep-'
      };
      var prefix = prefixes[which] || prefixes.all;

      overlay.querySelectorAll('[data-brand-letter]').forEach(function (jump) {
        var target = document.getElementById(prefix + jump.getAttribute('data-brand-letter'));
        var available = Boolean(target);
        jump.setAttribute('aria-disabled', String(!available));
        jump.classList.toggle('is-disabled', !available);
        jump.tabIndex = available ? 0 : -1;
        jump.setAttribute('href', available ? '#' + target.id : '#');
      });
    }

    function setSelected(which) {
      var map = {
        all: [tabAll, panelAll],
        lingerie: [tabLing, panelLing],
        swimwear: [tabSwim, panelSwim],
        apparel: [tabApp, panelApp],
        sleepwear: [tabSleep, panelSleep],
      };

      Object.keys(map).forEach(function (k) {
        var t = map[k][0], p = map[k][1];
        var active = k === which;
        if (t) t.setAttribute('aria-selected', String(active));
        if (p) p.hidden = !active;
      });
      updateLetterJumps(which);
    }

    function filter(term) {
      overlay.querySelectorAll('.brands-overlay__list li').forEach(function (li) {
        li.style.display = term && !li.textContent.toLowerCase().includes(term) ? 'none' : '';
      });
    }

    function open(which) {
      overlay.hidden = false;
      overlay.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('brands-overlay--open');
      setSelected(which || 'all');

      if (search) {
        search.value = '';
        filter('');
        search.focus();
      }
    }

    function close() {
      overlay.hidden = true;
      overlay.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('brands-overlay--open');
    }

    tabAll && tabAll.addEventListener('click', function () { open('all'); });
    tabLing && tabLing.addEventListener('click', function () { open('lingerie'); });
    tabSwim && tabSwim.addEventListener('click', function () { open('swimwear'); });
    tabApp && tabApp.addEventListener('click', function () { open('apparel'); });
    tabSleep && tabSleep.addEventListener('click', function () { open('sleepwear'); });

    closeBtn && closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') close();
    });

    search && search.addEventListener('input', function () {
      filter(search.value.trim().toLowerCase());
    });

    overlay.querySelectorAll('[data-brand-letter]').forEach(function (jump) {
      jump.addEventListener('click', function (event) {
        if (jump.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }

        var targetId = (jump.getAttribute('href') || '').slice(1);
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    document.addEventListener('click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;

      var text = (a.textContent || '').trim().toLowerCase();
      var href = (a.getAttribute('href') || '').toLowerCase();

      if (text.includes('brands a') || text.includes('brands a→z') || text.includes('brands a->z') || href.includes('/pages/brands')) {
        e.preventDefault(); open('all'); return;
      }
      if (text.includes('view all lingerie brands') || text.includes('a–z lingerie brands') || text.includes('a-z lingerie brands')) {
        e.preventDefault(); open('lingerie'); return;
      }
      if (text.includes('view all swimwear brands') || text.includes('a–z swimwear brands') || text.includes('a-z swimwear brands')) {
        e.preventDefault(); open('swimwear'); return;
      }
      if (text.includes('view all apparel brands') || text.includes('a–z apparel brands') || text.includes('a-z apparel brands')) {
        e.preventDefault(); open('apparel'); return;
      }
      if (text.includes('view all sleepwear brands') || text.includes('a–z sleepwear brands') || text.includes('a-z sleepwear brands')) {
        e.preventDefault(); open('sleepwear'); return;
      }
    });

    var p = location.pathname.toLowerCase();
    if (p === '/pages/all-lingerie-brands') open('lingerie');
    if (p === '/pages/all-swimwear-brands') open('swimwear');
    if (p === '/pages/all-apparel-brands') open('apparel');
    if (p === '/pages/all-sleepwear-brands') open('sleepwear');
  });
})();


/* Petticoat Lane collection/search filter navigation fallback */
(function () {
  if (window.__plFilterNavigationFallback) return;
  window.__plFilterNavigationFallback = true;

  var formSelector = '[data-sidebar-filter-form]';

  function destinationFromForm(form) {
    var url = new URL(window.location.href);

    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.indexOf('filter.') === 0 || key === 'page') {
        url.searchParams.delete(key);
      }
    });

    new FormData(form).forEach(function (value, key) {
      var text = String(value);
      if (key.indexOf('filter.') === 0 && text !== '') {
        url.searchParams.append(key, text);
      }
      if ((key === 'q' || key === 'sort_by') && text !== '') {
        url.searchParams.set(key, text);
      }
    });

    var query = url.searchParams.toString();
    return url.pathname + (query ? '?' + query : '') + url.hash;
  }

  function navigate(form) {
    var destination = destinationFromForm(form);
    if (destination !== window.location.pathname + window.location.search + window.location.hash) {
      window.location.assign(destination);
    }
  }

  document.addEventListener('change', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLInputElement || field instanceof HTMLSelectElement || field instanceof HTMLTextAreaElement) || field.disabled) return;

    var form = field.closest(formSelector);
    if (!form) return;

    event.stopImmediatePropagation();
    navigate(form);
  }, true);

  document.addEventListener('theme:range:update', function (event) {
    var form = event.target.closest ? event.target.closest(formSelector) : null;
    if (!form) return;

    event.stopImmediatePropagation();
    navigate(form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches(formSelector)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    navigate(form);
  }, true);

  document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-filter-update-url][href]') : null;
    if (!link || link.origin !== window.location.origin) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
})();
